/* global axios */
import ApiClient from '../ApiClient';

class EvolutionApiClient extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getQrCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_qr`);
  }

  getConnectionState(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_connection_state`);
  }

  restartConnection(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution_restart`);
  }

  forceNewQrCode(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution_force_new_qr`);
  }

  createVideoCallLink(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution_video_call_link`);
  }

  createRealtimeKitVideoCall(inboxId, conversationId) {
    return axios.post(
      `${this.url}/${inboxId}/evolution_realtimekit_video_call`,
      { conversation_id: conversationId }
    );
  }

  createGoogleMeetVideoCall(inboxId, conversationId) {
    return axios.post(`${this.url}/${inboxId}/google_meet_video_call`, {
      conversation_id: conversationId,
    });
  }
}

export default new EvolutionApiClient();
